import { QueryClient } from '@tanstack/react-query'
import { queryKeys } from '../queries/queryKeys'
import { isApiError } from '@counsel-project/client-utils'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors
        if (isApiError(error) && error.status.toString().startsWith('4')) {
          return false
        }
        return failureCount < 3
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      // Enable network mode to better handle offline/online scenarios
      networkMode: 'online',
    },
    mutations: {
      retry: 1,
      networkMode: 'online',
      throwOnError: true,
    },
  },
})

export const invalidateAllQueries = () => {
  queryClient.invalidateQueries({ queryKey: queryKeys.all })
}
